if (!process.env.VUE_APP_IS_WEB) {
  var RecipientDB = require("../database/models/Recipient");
}
import strings from "@/database/strings";

import RecipientORM from "@/store/orm-axios/models/Recipient";

import { _ } from "vue-underscore";

export default {
  FETCH(agencyId) {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new RecipientDB()
          .query({ where: { agency_id: agencyId, deleted: null } })
          .fetchAll()
          .then(res => {
            RecipientORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        RecipientORM.api()
          .FETCH(agencyId)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  GET(id) {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new RecipientDB({ id: id, deleted: null })
          .fetch()
          .then(res => {
            RecipientORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res.serialize());
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        RecipientORM.api()
          .GET(id)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  GET_BY_BUILDING_ID(buildingId) {
    if (!process.env.VUE_APP_IS_WEB) {
      // TODO Add process
    } else {
      return new Promise((resolve, reject) => {
        RecipientORM.api()
          .GET_BY_BUILDING_ID(buildingId)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  POST(item) {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new RecipientDB(item)
          .save()
          .then(res => {
            var configuration = res.serialize();
            RecipientORM.insertOrUpdate({
              data: configuration,
            });
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        RecipientORM.api()
          .POST(item)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  PUT(item) {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new RecipientDB(item)
          .save(null, { isUpdate: true })
          .then(res => {
            RecipientORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res.serialize());
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        RecipientORM.api()
          .PUT(item)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  DELETE(item) {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new RecipientDB(item)
          .save(null, { isDelete: true })
          .then(res => {
            RecipientORM.delete(item.id);
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        RecipientORM.api()
          .DELETE(item)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  GET_BY_MEETING(meetingId) {
    if (!process.env.VUE_APP_IS_WEB) {
      // TODO Add process
    } else {
      return new Promise((resolve, reject) => {
        RecipientORM.api()
          .GET_BY_MEETING(meetingId)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
};
